<div class="task-drawer" [formGroup]="taskForm">
  <div class="task-drawer-layout">
    <!-- LEFT: SIDEBAR (256px, collapsible) -->
    <app-task-sidebar [taskForm]="taskForm" [projectName]="getProjectName()" [taskId]="taskID || 'New'"
      [modules]="modulesList" [milestones]="milestones" [statuses]="statuses"
      [selectedMilestone]="getSelectedMilestone()" [assignees]="responsibleUsersArray" [observers]="observerArray"
      [participants]="participantArray" [savedDefaults]="savedDefaults" [tags]="taskTags" [completionPercentage]="completionPercentage"
      [createdOn]="model?.created_at" [isCollapsed]="isSidebarCollapsed" (onCollapse)="onSidebarCollapse($any($event))"
      (onSearch)="handleSearch($any($event))" (fieldChange)="handleFieldChange($any($event))"
      (statusChange)="handleStatusChange($any($event))" (moduleSelected)="selectedModule($any($event))"
      (referenceSelected)="onItemSelect($any($event))" (selfAssignChange)="handleSelfAssignChange($any($event))"
      (milestoneSelected)="handleMilestoneSelect($any($event))" (milestoneRemoved)="handleMilestoneRemove()"
      (assigneeSelectorOpened)="openUsersPopup($any($event), CONST_RESPONSIBLE_PERSON_TYPE)"
      (assigneeSelected)="handleAssigneeSelected($any($event))" (assigneeRemoved)="removeAssignee($any($event))"
      (defaultAssigneeChanged)="handleDefaultAssigneeChanged($any($event))"
      (observerSelectorOpened)="openUsersPopup($any($event), CONST_OBSERVER_TYPE)"
      (observerSelected)="handleObserverSelected($any($event))" (observerRemoved)="removeObserver($any($event))"
      (defaultObserverChanged)="handleDefaultObserverChanged($any($event))"
      (participantSelectorOpened)="openUsersPopup($any($event), CONST_PARTICIPANT_TYPE)"
      (participantSelected)="handleParticipantSelected($any($event))"
      (defaultParticipantChanged)="handleDefaultParticipantChanged($any($event))"
      (participantRemoved)="removeParticipant($any($event))" (timePlanningToggle)="hideShowTimePlanning()"
      (tagSelectorOpened)="openTagSelector()" (tagRemoved)="removeTagByIndex($any($event))"
      (tagsUpdated)="handleTagsUpdated($any($event))" (startDateChange)="handleStartDateChange($any($event))"
      (durationChange)="handleDurationChange($any($event))" (finishDateChange)="handleFinishDateChange($any($event))"
      [showModuleControls]="showModuleControls">
    </app-task-sidebar>

    <!-- RIGHT: MAIN CONTENT AREA -->
    <div class="task-main-area">
      <!-- HEADER -->
      <app-task-header [isEdit]="!!taskID" [taskTitle]="taskForm.get('title')?.value" [moduleLabel]="getModuleLabel()"
        [projectName]="getProjectName()" [projectId]="getRecordNumber()" [recordRoute]="getRecordRoute()" [status]="getStatusFromForm()"
        [statuses]="statuses" [selectedStatus]="getSelectedStatus()" [milestone]="getSelectedMilestone()"
        [isFullscreen]="isFullscreen" [isFormValid]="taskForm.valid" [searchQuery]="searchQuery" [templates]="templates"
        [hasTemplates]="templates && templates.length > 0" [stages]="stages" [selectedStage]="selectedStage"
        [hasStages]="stages && stages.length > 0" [isHighPriority]="CONST_HIGH_PRIORITY"
        [priority]="taskForm.get('priority')?.value || 2" (save)="save()" (close)="close()" (recordLinkClick)="close()" (delete)="onConfirmation()"
        (searchToggle)="onHeaderSearchToggle($any($event))" (searchChange)="onHeaderSearchChange($any($event))"
        (fullscreenToggle)="onFullscreenToggle($any($event))" (templateSelect)="populateTemplate($event)"
        (stageSelect)="addStage($event)" (priorityToggle)="changePriority()"
        [showFlag]="true" [flagged]="isTaskFlagged" [flagText]="taskFlagText" (flagSave)="saveFlag($event)">
      </app-task-header>

      <!-- MAIN CONTENT WITH TABS -->
      <app-task-main-content [taskForm]="taskForm" [selectedMilestone]="getSelectedMilestone()"
        [checklistCount]="getChecklistCount()" [attachmentsCount]="getAttachmentsCount()"
        [commentsCount]="taskComments.length" [activeTab]="activeTabIndex" [isTaskModule]="isTaskModule"
        [modulesList]="modulesList" [searchParams]="searchParams" [selectedItem]="selectedItem"
        [showSearchInput]="showSearchInput" [mentions]="mentions" [isMentionsLoading]="isMentionsLoading"
        [hideDetailsCommentsHistory]="!taskID" (tabChange)="handleTabChange($any($event))"
        (editDescription)="handleEditDescription()" (removeMilestone)="handleMilestoneRemove()"
        (moduleSelected)="selectedModule($any($event))" (itemSelected)="onItemSelect($any($event))"
        (itemCleared)="updateSearchInputFlag()" (mentionSelected)="getSelectedUser($any($event))"
        (mentionSearch)="getUsers($any($event))">

        <!-- DETAILS TAB CONTENT -->
        @if (taskID) {
          <div details-tab>
            <app-task-details-tab [taskForm]="taskForm" [status]="getStatusFromForm()" [statuses]="statuses"
              [statusId]="taskForm.get('status')?.value"
              [priority]="getPriorityText(taskForm.get('priority')?.value || 2)"
              [dueDate]="taskForm.get('due_date')?.value" [stage]="selectedStage?.name"
              [flagReason]="model?.is_flagged ? (model?.flag_text || '') : ''"
              [unflagReason]="!model?.is_flagged ? (model?.unflag_text || '') : ''"
              [canEditFlagReason]="true" (flagReasonSave)="saveFlagReason($event)"
              [assignee]="createdByArray?.full_name" [createdDate]="model?.created_at">
            </app-task-details-tab>
          </div>
        }

        <!-- CHECKLIST TAB CONTENT -->
        <div checklist-tab>
          <div class="tab-content-wrapper">
            <app-add-checklist (callback)="getChecklists($event)" [checkLists]="model?.check_list" [model]="model">
            </app-add-checklist>
          </div>
        </div>

        <!-- ATTACHMENTS TAB CONTENT -->
        <div attachments-tab>
          <div class="tab-content-wrapper">
            <!-- CREATE MODE: Use shared attachment component (no task ID yet) -->
            @if (!taskID) {
              <app-attachment
                [dropZoneId]="'taskAttachment'"
                [module_id]="TASK_MODULE_ID"
                [multipleUpload]="true"
                [allowAllFileTypes]="true"
                (callback)="handleAttachmentUpload($event)"
                (onDelete)="handleAttachmentDelete($event)">
              </app-attachment>
            }

            <!-- EDIT MODE: Use task-attachments component (task exists) -->
            @if (taskID) {
              <app-task-attachments
                [module_id]="TASK_MODULE_ID"
                [attachable_id]="taskID?.toString() || ''"
                [folder_id]="8194">
              </app-task-attachments>
            }
          </div>
        </div>

        <!-- COMMENTS TAB CONTENT -->
        @if (taskID) {
          <div comments-tab>
            <div class="tab-content-wrapper">
              <app-comments [taskID]="taskID" [model]="model" [isActiveTab]="activeTabIndex === 3"
                (commentAdded)="handleCommentAdded()">
              </app-comments>
            </div>
          </div>
        }

        <!-- HISTORY TAB CONTENT -->
        @if (taskID) {
          <div history-tab>
            <app-task-history-tab [history]="taskHistory" [taskId]="taskID?.toString()" [taskModel]="model">
            </app-task-history-tab>
          </div>
        }
      </app-task-main-content>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="task-footer">
    <!-- Left Section: Quick Actions -->
    <div class="footer-left">
      <button type="button" mat-button class="footer-action-btn" (click)="toggleFavorite()"
        [attr.aria-label]="isFavorite ? 'Remove from favorites' : 'Add to favorites'"
        [matTooltip]="isFavorite ? 'Remove from favorites' : 'Add to favorites'">
        <mat-icon>{{ isFavorite ? 'star' : 'star_border' }}</mat-icon>
        <span class="btn-text">Add to Favorites</span>
      </button>

      <span class="footer-separator">|</span>

      <button type="button" mat-button class="footer-action-btn" (click)="setReminder()"
        [attr.aria-label]="'Set reminder'" matTooltip="Set reminder">
        <mat-icon>notifications_none</mat-icon>
        <span class="btn-text">Set Reminder</span>
      </button>

      <!-- Save as Template (New Task Only) -->
      @if (!taskID) {
        <div class="save-template-wrapper">
          <span class="footer-separator">|</span>
          <mat-slide-toggle formControlName="is_template" class="save-template-toggle">
            Save as Template
          </mat-slide-toggle>
        </div>
      }
    </div>

    <!-- Right Section: Primary Actions -->
    <div class="footer-right">
      <!-- Delete Button (Edit Mode Only) -->
      <!-- <button *ngIf="taskID" type="button" mat-stroked-button class="footer-delete-btn" (click)="onConfirmation()"
      [attr.aria-label]="'Delete task'">
      <mat-icon>delete</mat-icon>
      <span class="btn-text">Delete</span>
    </button> -->

    <!-- Cancel Button -->
    <button type="button" mat-stroked-button class="footer-cancel-btn" (click)="close()" [attr.aria-label]="'Cancel'">
      <span class="btn-text">Cancel</span>
    </button>

    <!-- Save Button -->
    <button type="button" mat-raised-button class="footer-save-btn" (click)="save()"
      [disabled]="!taskForm.valid || isSaving" [attr.aria-label]="taskID ? 'Update task' : 'Save task'">
      @if (!isSaving) {
        <mat-icon>save</mat-icon>
      }
      @if (!isSaving) {
        <span class="btn-text">{{ taskID ? 'Update Task' : 'Save Task' }}</span>
      }
      @if (isSaving) {
        <span class="btn-text" style="display: inline-flex; align-items: center; gap: 8px;">
          <mat-spinner diameter="20" class="btn-spinner" style="display: inline-block;"></mat-spinner>
          {{ taskID ? 'Updating...' : 'Saving...' }}
        </span>
      }
    </button>
  </div>
</div>
</div>